import type {Currency} from "@fast-simon/types";
import {BCRates} from "../services/BCRates";
import type {BigcommerceCurrency} from "../@types/BCCurrency";
import {BCCurrenciesRates, BCSiteCurrency} from "../store/store";


export function getBCCurrentCurrency() {
    if (document.querySelectorAll('.js-active-currency').length > 0) {
        return document.querySelectorAll('.js-active-currency')[0].innerHTML;
    } else if (document.querySelector('[aria-controls="currencySelection"]') !== null) {
        return document.querySelector('[aria-controls="currencySelection"]').textContent.trim().replace("SELECT CURRENCY:", "").replace("Select Currency:", "").replace("Currency: \\n", "").replace("Select", "").replace("Currency:", "").replace(' ', '').replace(' ', '').trim();
    } else if (document.querySelector('div.currency-selector-wrapper span.form-selected-text') !== null) {
        return document.querySelector('div.currency-selector-wrapper span.form-selected-text').textContent.trim();
    } else if (document.querySelector('.navUser-action--currencySelector')!== null) {
        return document.querySelector('.navUser-action--currencySelector').firstElementChild.textContent.trim().replace("SELECT CURRENCY:", "").replace('Select Currency:', '').replace(' ', '').replace(' ', '').trim();
    } else if (document.querySelectorAll('span.currency-selector-active.button-text').length > 0) {
        return document.querySelector('span.currency-selector-active.button-text')[0].textContent;
    } else if (document.querySelector('.navUser .dropdownx .dropbtnx')!== null) {
        const country = document.querySelector('.navUser .dropdownx .dropbtnx').textContent;
        return getCurrencyByCountry(country);
    }
    return false;
}

function getCurrencyByCountry(country_raw) {
    const country = country_raw.toLowerCase().trim();
    let currency;
    switch (country) {
        case 'united states':
            currency = 'USD';
            break;
        case 'united kingdom':
            currency = 'GBP';
            break;
        case 'australia':
            currency = 'AUD';
            break;
        case 'france':
        case 'italia':
        case 'italy':
        case 'germany':
            currency = 'EUR';
            break;
        case 'switzerland':
            currency = 'CHF';
            break;
        case 'japan':
            currency = 'JPY';
            break;
        case 'thailand':
            currency = 'THB';
            break;
        default:
            currency = false;
    }

    return currency;
}

export function setBCSiteCurrency(currency: Currency) {
    BCSiteCurrency.set(currency);
}

export async function getBigcommerceCurrenciesRates() {
    try {
        const results = (await BCRates.get());
        BCCurrenciesRates.set(results.rates);
    } catch (e) {
        console.error(e);
    }
}


export function currentCurrencyRate(siteCurrency: Currency, curCurrency: Currency, BCCurrenciesRates: BigcommerceCurrency[]) {
    if (siteCurrency !== curCurrency) {
        const curRate = BCCurrenciesRates.find(item => item.currency_code === curCurrency);
        if (curRate) {
            return Number(curRate.currency_exchange_rate);
        }
    }
    return 1;
}
